// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-stile-button:hover,
.admin-stile-button:not(:focus),
.admin-stile-button:not(:active) {
  outline: none;
  border: none;
}

.admin-stile-header-h2 {
  margin-bottom: 7%;
  color: #fffafa;

  text-align: center;
  font-family: Ubuntu;
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 1.1px;
}

.admin-stile-section {
  display: flex;
  justify-content: center;
  width: 400px;
  text-align: start;
  flex-direction: column;
  background: #1d1c1c;
  box-shadow: 0px 8px 8px 2px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  margin: calc(0% + 7%) calc(5% - 15%) 0 calc(25% + 15%);
}
.admin-stile-select {
  color: #fff;
  background: #001767;
  font-family: Ubuntu;
  border-radius: 5px;
  font-size: 14px;
  border: none;
  margin: 0 67px 15px 67px;
  padding: 0.5rem 0.4rem;
  height: 1%;
  min-width: 50%;
  text-indent: 7px;
}
.admin-stile-select-s {
  margin: 0 65px;
  width: 270px;
  height: 35px;
  padding: 5px 0 5px 15px;
  background: none;
  color: #fff;
  background: #001767;
  border-radius: 5px;
  border: none;
  margin-bottom: 20px;
  font-size: 14px;
  letter-spacing: 0.7px;
  display: flex;
  justify-content: space-between;
}

.admin-stile-select:focus,
.admin-stile-select:active,
.admin-stile-select:not(:focus),
.admin-stile-select-s:focus,
.admin-stile-select-s:active,
.admin-stile-select-s:not(:focus) {
  outline: none;
  border: none;
}

.admin-boxes {
  position: relative;
  z-index: 1;
  width: 270px;
  padding: 0.3em 1.4em;
  color: #fff;
  background: #001767;
  border-radius: 0 0 5px 5px;
  margin-top: -23px;
  margin-bottom: 0px;
  margin-left: 65px;
  letter-spacing: 0.7px;
}

.admin-stile-label {
  font-size: 14px;
  font-family: Ubuntu;
  font-weight: 300;
  letter-spacing: 0.8px;
  color: #fff;
  margin-bottom: 4px;
  margin-left: 17%;
  text-align: start;
  display: flex;
  justify-content: flex-start;
  flex-flow: row nowrap;
}

.admin-stile-input {
  font-size: 14px;
  font-family: Ubuntu;
  letter-spacing: 0.7px;
  font-weight: 300;
  color: #ccc;
  flex-direction: column;
  background-color: #212121 !important;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25) inset;
  border-radius: 5px;
  margin: 0 60px 15px 60px;
  padding: 0.5rem 1rem;
}
.admin-stile-input-div {
  font-size: 14px;
  font-family: Ubuntu;
  letter-spacing: 0.7px;
  font-weight: 300;
  color: #ccc;
  flex-direction: column;
  background-color: #212121 !important;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25) inset;
  border-radius: 5px;
  margin: 0 60px 15px 60px;
  padding: 0.5rem 1rem;
}
input:focus,
input:active,
input:not(:focus) {
  outline: none;
  border: none;
  background: transparent;
  color: #cccccc;
  font-family: Ubuntu;
  letter-spacing: 0.7px;
  text-indent: 0px;
}

.admin-stile-button {
  color: #fff;
  border-radius: 5px;
  outline: none;
  border: none;
  text-align: center;
  font-family: Ubuntu;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 0.7px;

  padding: 0.4rem 2.7rem;
}

.admin-stile-button:hover:not(:active) {
  box-shadow: 4px 4px 2px #0000008e;
  font-size: 15px;
}

.check-buttons {
  display: flex;
  justify-content: center;
  flex-wrap: nowrap;
  gap: 20px;
  margin-top: 5%;
  margin-bottom: 15%;
}
.errors {
  position: fixed;
  margin: -37vh 4.5% 0;
  color: #ff6666;
  padding: auto;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  z-index: 999;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/pages/bots/create-admin/admin.css"],"names":[],"mappings":"AAAA;;;EAGE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;;EAEd,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,+CAA+C;EAC/C,mBAAmB;EACnB,sDAAsD;AACxD;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,wBAAwB;EACxB,sBAAsB;EACtB,UAAU;EACV,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,aAAa;EACb,8BAA8B;AAChC;;AAEA;;;;;;EAME,aAAa;EACb,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,oBAAoB;EACpB,WAAW;EACX,mBAAmB;EACnB,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,oCAAoC;EACpC,qDAAqD;EACrD,kBAAkB;EAClB,wBAAwB;EACxB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,oCAAoC;EACpC,qDAAqD;EACrD,kBAAkB;EAClB,wBAAwB;EACxB,oBAAoB;AACtB;AACA;;;EAGE,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;;EAErB,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,SAAS;EACT,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,uCAAuC;EACvC,YAAY;EACZ,kBAAkB;AACpB","sourcesContent":[".admin-stile-button:hover,\n.admin-stile-button:not(:focus),\n.admin-stile-button:not(:active) {\n  outline: none;\n  border: none;\n}\n\n.admin-stile-header-h2 {\n  margin-bottom: 7%;\n  color: #fffafa;\n\n  text-align: center;\n  font-family: Ubuntu;\n  font-size: 22px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  letter-spacing: 1.1px;\n}\n\n.admin-stile-section {\n  display: flex;\n  justify-content: center;\n  width: 400px;\n  text-align: start;\n  flex-direction: column;\n  background: #1d1c1c;\n  box-shadow: 0px 8px 8px 2px rgba(0, 0, 0, 0.25);\n  border-radius: 10px;\n  margin: calc(0% + 7%) calc(5% - 15%) 0 calc(25% + 15%);\n}\n.admin-stile-select {\n  color: #fff;\n  background: #001767;\n  font-family: Ubuntu;\n  border-radius: 5px;\n  font-size: 14px;\n  border: none;\n  margin: 0 67px 15px 67px;\n  padding: 0.5rem 0.4rem;\n  height: 1%;\n  min-width: 50%;\n  text-indent: 7px;\n}\n.admin-stile-select-s {\n  margin: 0 65px;\n  width: 270px;\n  height: 35px;\n  padding: 5px 0 5px 15px;\n  background: none;\n  color: #fff;\n  background: #001767;\n  border-radius: 5px;\n  border: none;\n  margin-bottom: 20px;\n  font-size: 14px;\n  letter-spacing: 0.7px;\n  display: flex;\n  justify-content: space-between;\n}\n\n.admin-stile-select:focus,\n.admin-stile-select:active,\n.admin-stile-select:not(:focus),\n.admin-stile-select-s:focus,\n.admin-stile-select-s:active,\n.admin-stile-select-s:not(:focus) {\n  outline: none;\n  border: none;\n}\n\n.admin-boxes {\n  position: relative;\n  z-index: 1;\n  width: 270px;\n  padding: 0.3em 1.4em;\n  color: #fff;\n  background: #001767;\n  border-radius: 0 0 5px 5px;\n  margin-top: -23px;\n  margin-bottom: 0px;\n  margin-left: 65px;\n  letter-spacing: 0.7px;\n}\n\n.admin-stile-label {\n  font-size: 14px;\n  font-family: Ubuntu;\n  font-weight: 300;\n  letter-spacing: 0.8px;\n  color: #fff;\n  margin-bottom: 4px;\n  margin-left: 17%;\n  text-align: start;\n  display: flex;\n  justify-content: flex-start;\n  flex-flow: row nowrap;\n}\n\n.admin-stile-input {\n  font-size: 14px;\n  font-family: Ubuntu;\n  letter-spacing: 0.7px;\n  font-weight: 300;\n  color: #ccc;\n  flex-direction: column;\n  background-color: #212121 !important;\n  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25) inset;\n  border-radius: 5px;\n  margin: 0 60px 15px 60px;\n  padding: 0.5rem 1rem;\n}\n.admin-stile-input-div {\n  font-size: 14px;\n  font-family: Ubuntu;\n  letter-spacing: 0.7px;\n  font-weight: 300;\n  color: #ccc;\n  flex-direction: column;\n  background-color: #212121 !important;\n  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25) inset;\n  border-radius: 5px;\n  margin: 0 60px 15px 60px;\n  padding: 0.5rem 1rem;\n}\ninput:focus,\ninput:active,\ninput:not(:focus) {\n  outline: none;\n  border: none;\n  background: transparent;\n  color: #cccccc;\n  font-family: Ubuntu;\n  letter-spacing: 0.7px;\n  text-indent: 0px;\n}\n\n.admin-stile-button {\n  color: #fff;\n  border-radius: 5px;\n  outline: none;\n  border: none;\n  text-align: center;\n  font-family: Ubuntu;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  letter-spacing: 0.7px;\n\n  padding: 0.4rem 2.7rem;\n}\n\n.admin-stile-button:hover:not(:active) {\n  box-shadow: 4px 4px 2px #0000008e;\n  font-size: 15px;\n}\n\n.check-buttons {\n  display: flex;\n  justify-content: center;\n  flex-wrap: nowrap;\n  gap: 20px;\n  margin-top: 5%;\n  margin-bottom: 15%;\n}\n.errors {\n  position: fixed;\n  margin: -37vh 4.5% 0;\n  color: #ff6666;\n  padding: auto;\n  border-radius: 5px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  z-index: 999;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
